module.exports = __webpack_public_path__ + "img/今日收益.98d0d332.png";